/* eslint-disable prefer-destructuring */
import React, { useMemo } from 'react';
import urlRegex from 'url-regex';

interface DetectLinksProps {
  content: string
}

const DetectLinks: React.FC<DetectLinksProps> = ({ content }) => {
  const linkedContent = useMemo(() => {
    const removePunctuation = (input: string) => {
      const puncs = [',', '.', ';', '!', ':', '?', '-'];
      let toReturn = input;
      puncs.forEach((p) => {
        if (input.endsWith(p)) {
          toReturn = input.slice(0, input.length - 1);
        }
      });
      return toReturn;
    };

    const ensureProtocol = (link: string) => {
      const deprotocoled = link.split('://');

      let toReturn = '';
      if (deprotocoled.length === 2) {
        toReturn = link;
      } else {
        toReturn = `http://${deprotocoled[0]}`;
      }

      toReturn = removePunctuation(toReturn);
      return toReturn;
    };

    const nodify = (link: string, label: string, idx: number) => (<a href={link} target='_blank' rel='noreferrer' key={idx}>{label}</a>);

    let text = content;

    const urlMatches = text.match(urlRegex({ strict: false })) || [];
    const childList: (JSX.Element|string)[] = [];

    urlMatches.forEach((l, idx) => {
      const link = removePunctuation(l);
      const pieces = text.split(link);
      if (pieces.length > 2) {
        text = pieces.slice(1, pieces.length).join(link);
      } else if (pieces.length === 2) {
        text = pieces[1];
      }
      childList.push(pieces[0]);
      childList.push(nodify(`${ensureProtocol(link)}`, removePunctuation(l), idx));
    });
    childList.push(text);
    return <>{childList}</>;
  }, [content]);

  return (
    linkedContent
  );
};

export default DetectLinks;
